import { render, staticRenderFns } from "./customInfo.vue?vue&type=template&id=260e5e5d&scoped=true&"
import script from "./customInfo.vue?vue&type=script&lang=js&"
export * from "./customInfo.vue?vue&type=script&lang=js&"
import style0 from "./customInfo.vue?vue&type=style&index=0&id=260e5e5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260e5e5d",
  null
  
)

export default component.exports